<div class="select-country-dialog-container">
    <div mat-dialog-content>
        <app-country-form 
            [errorObs]="errorObservable"
            (countrySelected)="countrySelected($event)">
        </app-country-form>
    </div>    
</div>